import TagManager from 'react-gtm-module'

import { appConfigContext } from 'nexchange-service/appServiceConfig'

const tagManagerArgs = {
    gtmId: appConfigContext.getAppConfig().GOOGLE_TAG_MANAGER_CONTAINER_ID,
}

const initializeTagTrackingManager = (): void => {
    try {
        // @ts-ignore
        window.dataLayer = window.dataLayer || []
        TagManager.initialize(tagManagerArgs)
    } catch (exception) {
        console.error(exception)
    }
}

export { initializeTagTrackingManager }
